export const templates = [
    {
        name: "@system/mobile/addons/user-profile/menu-card",
        loader: () => import("./UserProfileMenuCard"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/user-profile/generic-menu-card",
        loader: () => import("./UserProfileGenericMenuCard"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/user-profile/menus/userinfo",
        loader: () => import("./UserProfileMenuUserInfo"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/user-profile/menus/password",
        loader: () => import("./UserProfileMenuPassword"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/user-profile/userinfo",
        loader: () => import("./UserProfileUserInfo"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/user-profile/phone",
        loader: () => import("./UserProfilePhone"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/user-profile/third-part-sso",
        loader: () => import("./UserProfileThirdPartSso"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/user-profile/icninfo",
        loader: () => import("./UserProfileIcnInfo"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/settings/user-profile",
        loader: () => import("./SettingsUserProfile"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/settings/logout",
        loader: () => import("./SettingsLogout"),
        pure: true,
    },
];